import React from 'react';
import { RelativeHeader } from '../Header';
import { HeaderSlot } from '../../../utils/constants';
import Layout from '../Layout';
import { useLocation } from 'react-router-dom';

const Iframe = () => {
  const location = useLocation();

	const queryParams = new URLSearchParams(location.search);

  const widgetUrl = queryParams.get('widgetUrl');
	const accessToken = queryParams.get('accessToken');
	const clientId = queryParams.get('clientId');
  const src = `${widgetUrl}/login?accessToken=${accessToken}&clientId=${clientId}`;

	const headerProps = {
		slots: {
			left: {
				content: HeaderSlot.BACK,
			},
      center: {
				content: HeaderSlot.NAME,
				title: 'Loyalty',
        className: '!opacity-100 !translate-y-0 ml-2'
			},
		},
		parent: {
			border: {
				bottom: true,
			},
			className: {
				first: 'm-4',
			},
		},
	};

	const layoutProps = {
		className: {
			second: '!overflow-hidden !m-0 !p-0',
		},
	};

	return (
		<>
			<Layout {...layoutProps}>
				<RelativeHeader {...headerProps} />
				<div className='border-none'>
					<iframe src={src} className='w-full h-screen max-h-[91vh] border-none' sandbox='allow-same-origin allow-scripts allow-forms' allow="camera; microphone" />
				</div>
			</Layout>
		</>
	);
};

export default Iframe;
